import { useState, useEffect } from "react";

import ContactCard from "./ContactCard";
import ContactCardTop from "./ContactCardTop";

import { db } from "../firebase";
import { doc, deleteDoc, updateDoc, setDoc, onSnapshot } from "firebase/firestore";

import { Delete, X } from 'lucide-react';

const Overdues = ({ overdues, uid, setOverdues, setUpcoming, setCallbacks }) => {
  const [showContact, setShowContact] = useState(false);
  const [selectedContact, setSelectedContact] = useState({});
  const [callEnded, setCallEnded] = useState(false);
  const [contactCalled, setContactCalled] = useState({});
  const [showDateInput, setShowDateInput] = useState(false);

  const dateFormatOptions = {
    weekday: "short",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric"
  };

  const handleDeleteOverdue = async (contactId) => {
    const permission = window.confirm('Are you sure you want to delete this callback?');
    if (permission) {
      const contactDocRef = doc(db, 'autodialer', 'users', 'ids', uid, 'callbacks', contactId);
      await deleteDoc(contactDocRef);

      setOverdues(prev => {
        const i = prev.findIndex(contact => contact.id === contactId);
        const next = [...prev];
        next.splice(i, 1);
        return next;
      });

      setCallEnded(false);
    }
  }

  const handleSubmitNote = async (e) => {
    e.preventDefault();

    const note = e.target.note.value;
    const status = e.target.status.value;
    const name = e.target.name.value;
    const title = e.target.title.value;
    const email = e.target.email.value;

    if (e.target.callBack.checked === true) {
      const dueDate = new Date(e.target.dueDate.value);
      const updatedNotes = [...contactCalled.notes];
      updatedNotes.push({ noteDate: new Date(), noteText: note, status: status });
      const callBackDocRef = doc(db, "autodialer", "users", "ids", uid, "callbacks", contactCalled.id);
      const callbackDocData = {
        name: name,
        title: title,
        email: email,
        notes: updatedNotes,
        company: contactCalled.company,
        phone: contactCalled.phone,
        url: contactCalled.url,
        dueDate: dueDate
      }
      await setDoc(callBackDocRef, callbackDocData);
      callbackDocData.dueDate = { seconds: Math.floor(new Date(dueDate).getTime() / 1000) };
      callbackDocData.notes[callbackDocData.notes.length - 1].noteDate = { seconds: Math.floor(new Date().getTime() / 1000) };
      const now = new Date();
      const killMe = new Date(dueDate);
      const timeDelta = killMe.getTime() - now.getTime();
      const eightHours = 8 * 60 * 60 * 1000;
      if (timeDelta < eightHours) {
        setCallbacks(prev => [...prev, callbackDocData]);
      } else {
        setUpcoming(prev => [...prev, callbackDocData]);
      }
      setOverdues(prev => {
        const i = prev.findIndex(contact => contact.id === contactCalled.id);
        const next = [...prev];
        next.splice(i, 1);
        return next;
      });
      setCallEnded(false);
      setShowDateInput(false);
    } else {
      alert('You must set a new callback date.');
    }
  }

  useEffect(() => {
    const docRef = doc(db, "autodialer", "users", "ids", uid);
    const unsub = onSnapshot(docRef, (doc) => {
      console.log("Listening for zoom events...");
      const docData = doc.data();
      const event = docData.zoomEvents.event;
      if (event === "phone.caller_ended") {
        setCallEnded(true);
        updateDoc(docRef, { zoomEvents: {} });
      }
    });
    return () => unsub();
  }, [uid]);

  return (
    <div className='page-wrapper'>
      <div className='callbacks-list'>
        <ul>
          {
            overdues.map((contact) => {
              return (
                <div className='callback' key={contact.dueDate.seconds}>
                  <div className='callback-header'>
                    {new Date(contact.dueDate.seconds * 1000).toLocaleTimeString("en-US", dateFormatOptions).replace(" at ", ' • ')}
                    <button className='menu-btn' onClick={() => handleDeleteOverdue(contact.id)}>
                      <Delete size={'1.4rem'} />
                    </button>
                  </div>
                  <ContactCardTop clickable={true} selectedContact={contact} setSelectedContact={setSelectedContact} setShowContact={setShowContact} setContactCalled={setContactCalled} />
                </div>
              )
            })
          }
        </ul>
      </div>
      {
        showContact &&
        <div className='lightbox'>
          <div className='lightbox-header'>
            Contact card
            <button className='close-btn' onClick={() => setShowContact(false)}>
              <X size={'1.2rem'} />
            </button>
          </div>
          <div className='lightbox-modal'>
            <ContactCard
              selectedContact={selectedContact}
            />
          </div>
        </div>
      }
      {
        callEnded &&
        <div className='lightbox'>
          <div className='lightbox-header'>
            Call notes
            <button className='close-btn' onClick={() => { setCallEnded(false) }}>
              <X size={'1.2rem'} />
            </button>
          </div>
          <div className='lightbox-modal'>
            <form className='call-notes' onSubmit={(e) => handleSubmitNote(e)}>
              <div className='input-group'>
                <label>
                  Contact name
                  <input type="text" name="name" placeholder='John' defaultValue={contactCalled.name} />
                </label>
                <label>
                  Title
                  <input type="text" name="title" placeholder='Manager' defaultValue={contactCalled.title} />
                </label>
              </div>
              <label>
                Company
                <input type="text" name="company" placeholder='Acme Inc' defaultValue={contactCalled.company} />
              </label>
              <label>
                Email
                <input type="text" name="email" placeholder='john@acme.com' defaultValue={contactCalled.email} />
              </label>
              <label>
                Call status
                <select name="status">
                  {
                    ["", "interested", "warm", "cold", "left-message", "no-answer", "not-interested"].map((status) => {
                      return (
                        <option value={status} key={status}>{status.replace("-", " ")}</option>
                      )
                    })
                  }
                </select>
              </label>
              <label className='checkbox-wrapper' >
                <input type="checkbox" name="callBack" onChange={() => setShowDateInput(prev => !prev)} /> Callback
              </label>
              {showDateInput && <input type="datetime-local" name="dueDate" />}
              <label htmlFor="note">
                Note
                <textarea name="note" rows={3} placeholder='Brief description of the call...' />
              </label>
              <div className='btn-group'>
                <button className='main-btn'>
                  Save
                </button>
                <button className='main-btn' style={{ backgroundColor: 'var(--ui-red)' }} type='button' onClick={() => handleDeleteOverdue(contactCalled.id)}>
                  Delete
                </button>
              </div>
            </form>
          </div>
        </div>
      }
    </div >
  );
}

export default Overdues;